import { TimelineLite, Power0, Power1, Back }  from 'gsap';

const animation = (audioFn) => {
    const tl = new TimelineLite();

    tl.eventCallback('onStart', audioFn)
        .set(['.begin-btn', '.replay-section'], {pointerEvents: 'none'})
        .from('.homepage__heading', .8, {alpha: 0, ease: Power0.easeNone })
        .from('.homepage__content', .8, {alpha: 0, ease: Power0.easeNone }, '+=.2')
        .from('#blue-hand', .8, {y: 50, transformOrigin:"50% 50%", alpha: 0, delay: .5 }, '+=.2')
        .from('#blue-heart', .8, {alpha: 0, scale: 0.3, transformOrigin:"50% 50%", ease: Back.easeInOut.config(1.4)})
        .from('#blue-heart', 2, {y: 180, transformOrigin:"50% 50%", ease: Power1.easeInOut, repeat: -1, yoyo:true }, 4)
        .from('#blue-monitor', .8, {alpha: 0, y: '+=30', transformOrigin:"50% 50%", ease: Power1.easeInOut}, '-=1.5')
        .from('#white-paper', 1, {alpha: 0, scaleY: 0, transformOrigin:"0% 100%", delay: .1, ease: Power1.easeInOut},  '-=.3')
        .staggerFrom('.orange-text', 0.7, {alpha: 0, scaleX: 0, ease: Back.easeInOut.config(1.4)}, 0.5)
        .from(['#green-heart-bg-blue-circle', '#green-heart'], .8, {alpha: 0, scale: 0, transformOrigin:"50% 50%", ease: Back.easeInOut.config(1.7)}, '-=.3' )
        .from('#notes', .8, {alpha: 0, y: 50, transformOrigin:"50% 50%", delay: .5})
        .staggerFrom('.gray-text', 0.4, {alpha: 0, scaleX: 0, ease: Back.easeOut.config(1.4)}, 0.25)
        .from('#blue-dot', .8, {alpha: 0, scale: 0, transformOrigin:"50% 50%", ease: Back.easeInOut.config(1.7)} )
        .set('.begin-btn', {pointerEvents: 'all'})
        .from('.begin-btn', .8, {alpha: 0, delay: .5, ease: Power0.easeNone}, '+=.3')
        .set('.replay-section', {pointerEvents: 'auto'})
        .from('.replay-section', .8, {alpha: 0, delay: 0.5, ease: Power0.easeNone})        
}

export default animation
